// What changed in each release, newest first. Shown in Help > What's new and,
// once per release, as a notice at the top of the console.
//
// To release: add an entry at the TOP with the new version, set APP_VERSION in
// src/version.js (and "version" in package.json). Keep each line short and in
// plain words for the people who run the service. type: 'new' | 'improved' | 'fixed'.

export const CHANGELOG = [
  {
    version: '2.0.0',
    date: 'October 2026',
    title: 'SleekHear 2.0',
    summary: 'Run a whole service from one place, from any device.',
    changes: [
      { type: 'new', text: 'Service run-sheet: plan scriptures, songs and text slides ahead, then step through them with the arrow keys.' },
      { type: 'new', text: 'Phone remote: scan a QR code and a volunteer can move the run-sheet and send slides live from their phone.' },
      { type: 'new', text: 'Livestream output for OBS: verses and lyrics as a lower third on your stream.' },
      { type: 'new', text: 'Stage screen for the preacher and band: current slide, next slide, next item and a clock.' },
      { type: 'new', text: 'Long Bible passages and lyrics are split into slides. Step with the buttons or the up and down arrow keys.' },
      { type: 'new', text: 'Browse books: pick a book, chapter and verses by clicking, with next and previous chapter.' },
      { type: 'new', text: 'Backgrounds: colours, gradients and your own images, with text shadow and outline.' },
      { type: 'new', text: 'Your songs, verses, run-sheets, settings and background images now follow your login to any computer.' },
      { type: 'new', text: 'Works offline: the app, your saved data and the verses you have used keep working if the internet drops.' },
      { type: 'new', text: 'CCLI song usage: see how often each song was shown and download a report.' },
      { type: 'new', text: 'Sermon notes: discussion questions, a weekly takeaway, copy, and a printable handout you can save as PDF.' },
      { type: 'improved', text: 'A cleaner layout: Staging and Live always stay in view, and the header says what the congregation can see.' },
      { type: 'improved', text: 'Messages appear at the bottom of the screen instead of pop-up boxes that freeze the page.' },
      { type: 'improved', text: 'Settings is now a roomy panel with Text & slides, Background and General tabs, and AI Tools shows what the AI has heard before you summarize.' },
      { type: 'improved', text: 'Song search finds the right song more reliably when you speak or type a title.' },
      { type: 'fixed', text: 'Typing references like "Psalm 23" or "John 316" no longer turns into the wrong verse.' },
      { type: 'fixed', text: 'The keyboard shortcuts list now shows the keys that really work.' },
      { type: 'fixed', text: 'Deleted songs, verses and plans no longer come back after syncing two computers.' },
    ],
  },
  {
    version: '1.0.0',
    date: 'Earlier',
    title: 'SleekHear 1.0',
    summary: 'The first release.',
    changes: [
      { type: 'new', text: 'Voice-activated Bible verse detection.' },
      { type: 'new', text: 'AI song search by speaking or singing, and a worship song library.' },
      { type: 'new', text: 'Staging and Live, with a separate congregation display window.' },
      { type: 'new', text: 'AI sermon summary and multiple Bible versions.' },
    ],
  },
];

export const latestRelease = () => CHANGELOG[0];
